import React, { useState, useEffect } from "react";
// import Map from './Map'
import Links from "./Links";
let Map;
const RightCol = () => {
  const [showMap, setShowMap] = useState(false);
  useEffect(() => {
    (async () => {
      if (window && !Map) {
        const { default: MapContainer } = await import("./Map");
        Map = MapContainer;
        setShowMap(true);
      }
    })();
  });

  return (
    <aside className="srp-right-col ux-row-col">
      {showMap && Map && <Map />}
      <Links />
    </aside>
  );
};

export default RightCol;
